CheckoutV2.PaymentV2.Balances = function(checkout, $container) {
    var balances = this;

    this.$availableBalancesContainer = $('.js-available-balances');
    this.$giftCardsContainer = $('.js-gift-card');

    this.$inStore = this.$availableBalancesContainer.find('.js-payment-store-credit-wrap');
    this._inStoreBalance = __fixDecimals(checkout.session.get('credits.instoreBalance'));

    this.$rewards = this.$availableBalancesContainer.find('.js-payment-rewards-wrap');
    this._rewardsBalance = __fixDecimals(checkout.session.get('credits.rewardBalance'));

    this.$giftCards = this.$giftCardsContainer.find('.js-payment-gift-card-wrap');
    this._giftCardsBalance = __fixDecimals(checkout.session.get('credits.giftCardBalance'));

    // If your account has any values added for gift cards, rewards, or in store, you can use these
    // to override the session data and test different balance amounts without having to mess with the db.
    // The checkout submit will fail of course, but you can debug the horror of the balancing
    // logic below with different data sets fairly quickly if you don't want to use the browser console to
    // change things using checkout.payment.balances functions.
    // If you want to use the internal stuff through console:
    //   checkout.payment.balances._inStoreBalance = <float>
    //   checkout.payment.balances._rewardsBalance = <float>
    //   checkout.payment.balances._giftCardsBalance = <float>
    // And to get everything to update:
    //   checkout.payment.balances.adjustActiveBalances();

    // this._inStoreBalance = 35.00;
    // this._rewardsBalance = 30.00;
    // this._giftCardsBalance = 150.00;

    this._activeBalances = [];

    /**
     * Balances rules:
     * 1. Rewards have an expiration date. As a result, they should always be applied first when checked.
     * 2. Rewards, in store, and gift cards are all stackable with a normal payment method
     * 3. The usage of rewards, gift cards, and balances, or any combo of the three, can be the whole total.
     *    At that point, the payment methods panel should hide and remove the active payment method on the panel
     *
     * checkout.session.useRewards = 1 if rewards are used
     * checkout.session.useBalance = 1 if in store balance is used
     * checkout.session.useGiftCards = 1 if gift card balance is used
     *
     * session data should look like this:
     * 
     * session.totals.balances['ECS Rewards'] = <amount>
     * session.totals.balances['ECS Store Credit'] = <amount>
     * session.totals.balances['Gift Cards'] = <amount>
     *
     * session.totals.credits = <sum of above>
     */

    this._init = function() {
        if(balances._rewardsBalance > 0){
            balances._renderRewards();
        }

        if(balances._inStoreBalance > 0) {
            balances._renderInStore();
        }

        if(balances._giftCardsBalance > 0) {
            balances._renderGiftCards();
        }

        balances._listen();
    };

    this._renderRewards = function() {
        balances.$rewards.removeClass('hidden');
        balances.$rewards.find('label').html(balances._getInputHtml('rewards'));
    };

    this._renderInStore = function() {
        balances.$inStore.removeClass('hidden');
        balances.$inStore.find('label').html(balances._getInputHtml('instore'));
    };

    this._disableInStore = function(){
        balances.$inStore.find('input').prop('checked', false);
        balances.$inStore.find('input').prop('disabled', true);
    };

    this._enableInStore = function(){
        balances.$inStore.find('input').prop('disabled', false);
    };

    this._renderGiftCards = function() {
        balances.$giftCards.removeClass('hidden');
        balances.$giftCards.find('label').html(balances._getInputHtml('giftcard'));
    };

    this._disableGiftCards = function(){
        balances.$giftCards.find('input').prop('checked', false);
        balances.$giftCards.find('input').prop('disabled', true);
    };

    this._enableGiftCards = function(){
        balances.$giftCards.find('input').prop('disabled', false);
    };

    this._onGiftCardAdded = function(balance) {
        var data = checkout.session.get('credits');
        data['giftCardBalance'] = balance;
        checkout.session.set({'credits' : data});

        balances._giftCardsBalance = __fixDecimals(balance);
        balances.adjustActiveBalances();
        balances._renderGiftCards();
        balances.renderRemainingAmounts();
        checkout.payment.giftCardModal.hide();
        checkout.payment.setActiveBalanceMethods(balances._activeBalances);
    };

    this._listen = function() {
        // Listener for rewards checkbox
        balances.$rewards.find('input[type="checkbox"]').on('change', function(){
            var checked = $(this).prop('checked');
            if(!checked){
                balances._removeActiveBalance('rewards');
                balances.adjustActiveBalances();
                balances.renderRemainingAmounts();
                checkout.payment.setActiveBalanceMethods(balances._activeBalances);
                return;
            }
            balances._addActiveBalance('rewards', balances._rewardsBalance);
        });

        // Listener for in store credits checkbox
        balances.$inStore.find('input[type="checkbox"]').on('change', function(){
            var checked = $(this).prop('checked');
            if(!checked){
                balances._removeActiveBalance('instore');
                balances.adjustActiveBalances();
                balances.renderRemainingAmounts();
                checkout.payment.setActiveBalanceMethods(balances._activeBalances);
                return;
            }
            balances._addActiveBalance('instore', balances._inStoreBalance);
        });

        // Listener for gift cards checkbox
        balances.$giftCards.find('input[type="checkbox"]').on('change', function(){
            var checked = $(this).prop('checked');
            if(!checked){
                balances._removeActiveBalance('giftcard');
                balances.adjustActiveBalances();
                balances.renderRemainingAmounts();
                checkout.payment.setActiveBalanceMethods(balances._activeBalances);
                return;
            }
            balances._addActiveBalance('giftcard', balances._giftCardsBalance);
        });

        // Listener for gift cards modal open click
        balances.$giftCardsContainer.find('.js-apply-gift-card').on('click', function(e) {
            e.preventDefault();
            checkout.payment.giftCardModal.setCardAddedCallback(balances._onGiftCardAdded);
            checkout.payment.giftCardModal.show();
        });

    };

    // Builds and returns the html content for each method label
    this._getInputHtml = function(type) {
        var siteName = checkout.config.siteNameFirstWord;
        var content = '';
        switch (type) {
            case 'rewards':
                content = 'Use your $' + balances._rewardsBalance.toMoney() + ' ' + siteName + ' Rewards balance';
                break;
            case 'instore':
                content = 'Use your $' + balances._inStoreBalance.toMoney() + ' ' + siteName + ' Store Credit balance';
                break;
            case 'giftcard':
                content = 'Use your $' + balances._giftCardsBalance.toMoney() + ' Gift Cards balance';
                break;
        }

        content += ' <span class="js-remaining-wrap text-success hidden">($<span class="js-amount"></span> remaining)</span>';
        return content;
    };

    // Called by payment to update the balance amounts when the cart changes in value
    this.updateActiveBalances = function() {
        balances.adjustActiveBalances();
        balances.renderRemainingAmounts();
        checkout.payment.setActiveBalanceMethods(balances._activeBalances, true);
    };

    // In the case when the user logs in through the log in modal on checkout, the session data doesn't have
    // the full balances yet. We need to trigger this in the payment step to see if the numbers have changed since init.
    this.updateBalanceAvailableAmounts = function() {
        // These can be NaN because the server likes to send back numbers that aren't numbers or doesn't provide the
        // field for an ECS credit that doesn't exist. Should just be zero but whatever.
        var newInstore = __fixDecimals(checkout.session.get('credits.instoreBalance'));
        var newRewards = __fixDecimals(checkout.session.get('credits.rewardBalance'));
        var newGiftCards = __fixDecimals(checkout.session.get('credits.giftCardBalance'));

        if(balances._rewardsBalance !== newRewards && !isNaN(newRewards)) {
            balances._rewardsBalance = newRewards;
            balances._renderRewards();
        }

        if(balances._inStoreBalance !== newInstore && !isNaN(newInstore)) {
            balances._inStoreBalance = newInstore;
            balances._renderInStore();
        }

        if(balances._giftCardsBalance !== newGiftCards && !isNaN(newGiftCards)) {
            balances._giftCardsBalance = newGiftCards;
            balances._renderGiftCards();
        }
    };

    // Renders the amount remaining content for each available balance method and sets disabled states on inputs
    this.renderRemainingAmounts = function(){
        // Start with all these hidden and defaulted to the full amount
        balances.$rewards.find('.js-remaining-wrap').addClass('hidden');
        balances.$rewards.find('.js-remaining-wrap').find('.js-amount').html(balances._rewardsBalance.toMoney());
        balances.$inStore.find('.js-remaining-wrap').addClass('hidden');
        balances.$inStore.find('.js-remaining-wrap').find('.js-amount').html(balances._inStoreBalance.toMoney());
        balances.$giftCards.find('.js-remaining-wrap').addClass('hidden');
        balances.$giftCards.find('.js-remaining-wrap').find('.js-amount').html(balances._giftCardsBalance.toMoney());

        var rewardsAmount = 0;
        var instoreAmount = 0;
        var giftcardsAmount = 0;

        var diff = 0;
        balances._activeBalances.forEach(function(item){
            switch (item.type){
                case 'rewards':
                    rewardsAmount = item.amount;
                    diff = balances._rewardsBalance - rewardsAmount;
                    balances.$rewards.find('.js-remaining-wrap').find('.js-amount').html(diff.toMoney());
                    balances.$rewards.find('.js-remaining-wrap').removeClass('hidden');
                    break;
                case 'instore':
                    instoreAmount = item.amount;
                    diff = balances._inStoreBalance - instoreAmount;
                    balances.$inStore.find('.js-remaining-wrap').find('.js-amount').html(diff.toMoney());
                    balances.$inStore.find('.js-remaining-wrap').removeClass('hidden');
                    break;
                case 'giftcard':
                    giftcardsAmount = item.amount;
                    diff = balances._giftCardsBalance - giftcardsAmount;
                    balances.$giftCards.find('.js-remaining-wrap').find('.js-amount').html(diff.toMoney());
                    balances.$giftCards.find('.js-remaining-wrap').removeClass('hidden');
                    break;
            }
        });

        var balancesTotal = rewardsAmount + instoreAmount + giftcardsAmount;
        var cartTotal = __fixDecimals(checkout.cart.totals.values.total);

        if(balancesTotal === cartTotal){ // balances cover cart fully, disable un needed inputs.
            // rewards always stays unchecked.
            if(instoreAmount === 0){
                balances._disableInStore();
            }
            if(giftcardsAmount === 0){
                balances._disableGiftCards();
            }
        }
    };

    // Add a balance from a checkbox and adjust each balance amount based on the selection
    this._addActiveBalance = function(type, amount) {
        var data = {
            type: type,
            amount: __fixDecimals(amount)
        };
        balances._activeBalances.push(data);
        // Adjust the list of balances and their amounts
        balances.adjustActiveBalances();
        // Render/ update the remaining amounts for each card
        balances.renderRemainingAmounts();
        // Send the balance methods to payment
        checkout.payment.setActiveBalanceMethods(balances._activeBalances);
    };

    this._removeActiveBalance = function(type) {
        balances._activeBalances = balances._activeBalances.filter(function(item) {
            return item.type !== type;
        });
    };

    this._getBalancesSum = function(){
        var sum = 0;
        balances._activeBalances.forEach(function(item) {
            sum += item.amount;
        });
        return __fixDecimals(sum);
    };

    this._updateActiveBalance = function(type, amount){
        balances._activeBalances.forEach(function(item){
            if(item.type === type) {
                item.amount = __fixDecimals(amount);
            }
        });
    };

    // This is a doozy. I'm sure it could be better, but this is what I built.
    // Rewards take priority over all other methods, in that if we have any combination of credits selected,
    // rewards needs to be applied fully. 'skipReset' is needed when we recurse through the method in order
    // to not set the default amounts from session
    this.adjustActiveBalances = function(skipReset) {
        // Set all existing active balances to their full default amount before adjustment
        if(!skipReset){
            balances._activeBalances.forEach(function(item){
                switch (item.type) {
                    case 'rewards':
                        item.amount = __fixDecimals(balances._rewardsBalance);
                        break;
                    case 'instore':
                        item.amount = __fixDecimals(balances._inStoreBalance);
                        break;
                    case 'giftcard':
                        item.amount = __fixDecimals(balances._giftCardsBalance);
                        break;
                }
            });
        }

        // Enable all checkboxes
        balances._enableGiftCards();
        balances._enableInStore();

        var cartTotal = __fixDecimals(checkout.cart.totals.values.total);
        var balanceSum = balances._getBalancesSum();
        var overpay = __fixDecimals(balanceSum - cartTotal); // amount of overpayment we need to reduce

        var rewards = balances._getActiveBalanceByType('rewards');
        var instore = balances._getActiveBalanceByType('instore');
        var giftcard = balances._getActiveBalanceByType('giftcard');

        if(rewards){ // always apply rewards first
            if(rewards.amount >= cartTotal) { // rewards will be the only active method.
                if(cartTotal < rewards.amount){ // adjust the rewards amount to match the total
                    rewards.amount = __fixDecimals( rewards.amount - (rewards.amount - cartTotal) );
                }

                // clear out the active balances and add only rewards
                balances._removeActiveBalance( "instore"  );
                balances._disableInStore();
                balances._removeActiveBalance( "giftcard" );
                balances._disableGiftCards();

            } else if(balanceSum > cartTotal){ // non rewards payment method needs to be adjusted down
                if(instore && instore.amount >= overpay){ // in store can cover the difference
                    if(instore.amount === overpay){ // remove instore if it is the exact amount
                        balances._removeActiveBalance('instore');
                    } else {
                        balances._updateActiveBalance('instore', instore.amount - overpay);
                    }
                } else if(giftcard && giftcard.amount >= overpay) { // giftcard covers the difference
                    if(giftcard.amount === overpay){
                        balances._removeActiveBalance('giftcard');
                    } else {
                        balances._updateActiveBalance('giftcard', giftcard.amount - overpay);
                    }
                } else if(giftcard && instore && giftcard.amount + instore.amount >= overpay) { // giftcard and instore cover
                    if(overpay - instore.amount < giftcard.amount){ // gift card amount can cover it
                        balances._removeActiveBalance('instore');
                        balances.adjustActiveBalances(true); // re adjusts the balances after the removal with no reset
                    } else if(overpay - giftcard.amount < instore.amount){ // instore amount can cover it
                        balances._removeActiveBalance('giftcard');
                        balances.adjustActiveBalances(true); // re adjusts the balances after the removal with no reset
                    }
                }
            }
        } else {
            if(balanceSum > cartTotal) { // one of the credits needs to be adjusted down
                if(instore && instore.amount >= overpay){ // in store can cover the difference
                    balances._updateActiveBalance('instore', instore.amount - overpay);
                } else if(giftcard && giftcard.amount >= overpay) { // giftcard covers the difference
                    balances._updateActiveBalance('giftcard', giftcard.amount - overpay);
                }
            }
        }
    };

    this.getActiveBalances = function() {
        return balances._activeBalances;
    };

    this._getActiveBalanceByType = function(type){
        var result = balances._activeBalances.filter(function(item){
            return item.type === type;
        });

        if(result.length > 0){
            return result[0];
        }

        return null;
    };

    this._init();
};
